import { RouteConfig } from "vue-router";

const saldoCuentas: RouteConfig = {
  path: "/saldoCuentas",
  name: "saldoCuentas",
  component: () => import(/* webpackChunkName: "saldo-cuentas" */ "@/views/SaldoCuentas.vue"),
};

export default saldoCuentas;
